
























































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { BModal, BCarousel } from 'bootstrap-vue';
import { Sheet, Examinee, SheetActivity } from "../../modules/teacher/SendAnswerImage"


export interface Data {
  sheet_id: string
  sheet: Sheet
  examinees: Examinee[]
  classroom_fields: any[]
  mail_fields: any[]
  isAllChecked: boolean
  selected_ids: number[]
  isMail: boolean
  isClassroom: boolean
  modalExaminee: Examinee
  carouselPageIdx: number
  windowHeight: number
  isShowCarousel: boolean
  isAllCheckedStopPublishing: boolean
  progress: string
  isDispProgress: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: new Sheet({}),
      examinees: new Array<Examinee>(),
      classroom_fields: [
        {key: "select", label: "選択", class: 'text-center b-table-th-td'},
        {key: "course_name", label: "コース", class: 'text-center b-table-th-td'},
        {key: "room_name", label: "クラス", class: 'text-center b-table-th-td'},
        {key: "student_no", label: "出席番号", class: 'text-center b-table-th-td'},
        {key: "student_no_character", label: "学籍番号", class: 'text-center b-table-th-td'},
        {key: "student_name", label: "氏名", class: 'text-center b-table-th-td'},
        {key: "score", label: "得点", class: 'text-center b-table-th-td'},
        {key: "last_sent_at", label: "返却日時", class: 'text-center b-table-th-td'},
        {key: "is_stop_publishing", label: "公開停止", class: 'text-center b-table-th-td'},
        {key: "preview", label: "答案", class: 'text-center'},
      ],
      mail_fields: [
        {key: "select", label: "選択", class: 'text-center b-table-th-td'},
        {key: "room_name", label: "クラス", class: 'text-center b-table-th-td'},
        {key: "student_no", label: "出席番号", class: 'text-center b-table-th-td'},
        {key: "student_no_character", label: "学籍番号", class: 'text-center b-table-th-td'},
        {key: "student_name", label: "氏名", class: 'text-center b-table-th-td'},
        {key: "email", label: "Mail", class: 'text-center b-table-th-td'},
        {key: "score", label: "得点", class: 'text-center b-table-th-td'},
        {key: "last_sent_at", label: "返却日時", class: 'text-center b-table-th-td'},
        {key: "is_stop_publishing", label: "公開停止", class: 'text-center b-table-th-td'},
        {key: "preview", label: "答案", class: 'text-center'},
      ],
      isAllChecked: false,
      selected_ids: [],
      isMail: context.root.$route.path.indexOf("mail") != -1,
      isClassroom: context.root.$route.path.indexOf("classroom") != -1,
      modalExaminee: new Examinee({}),
      carouselPageIdx: 0,
      windowHeight: 0,
      isShowCarousel: false,
      isAllCheckedStopPublishing: false,
      progress: "0.0",
      isDispProgress: false,
      errors: [],
    });

    /************************************************************
     * テーブルフィールド
     ************************************************************/

    const tableFields = computed(() => {
      return state.isMail ? state.mail_fields : state.isClassroom ? state.classroom_fields : [];
    });

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDateText = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "";
    };

    /************************************************************
     * 生徒一覧のcss
     ************************************************************/

    const rowStyle = (idx: number, examinee: Examinee) => {
      const rtn: any = idx % 2 == 1 ? {'background-color': '#f2f2f2'} : {'background-color': 'white'};
      if(examinee.returnCompleted){
        rtn["text-decoration"] = "line-through";
      }
      return rtn;
    }

    /************************************************************
     * 答案返却ボタン押下
     ************************************************************/

    const sendAnswerImage = async () => {
      if (state.selected_ids.length == 0) {
        alert('答案返却対象の生徒を選択してください。');
        return;
      }

      // if(state.examinees.filter(x => x.is_stop_publishing && state.selected_ids.includes(x.id)).length > 0){
      //   alert("公開停止中の生徒が選択されています。公開停止中生徒は返却処理を行えません。");
      //   return;
      // }

      if (state.isMail && state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id) && !x.email).length > 0) {
        alert('メールアドレスが設定されていない生徒が選択されています。\n生徒一覧から設定してください。');
        return;
      }

      if (!confirm('選択された生徒に答案を返却します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const examinees = state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id)).map((x: Examinee) => new Examinee(x));
      let method = "";
      let params = {};
      if (state.isMail) {
        method = "create_mail";
        params = {sheet_id: state.sheet_id, examinees: examinees};
      } else if (state.isClassroom) {
        method = "create_classroom";
        params = {sheet_id: state.sheet_id, examinees: examinees, credentials: context.root.$store.state.gauthCredentials};
      }

      await http.post(`/api/teacher/send_answer_image/${method}`, params).then(response => {
        if (response.data.error_type == "gapiAuthError") {
          alert("googleapiの認証に失敗しました。試験一覧に戻ります。");
          context.root.$store.dispatch('goSheetList');
        } else {  
          alert("処理が完了しました。");
          context.root.$store.dispatch('goSheetList');
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 答案返却ボタン押下(Mail)
     ************************************************************/

    const sendAnswerImageMail = async () => {

      if (state.selected_ids.length == 0) {
        alert('答案返却対象の生徒を選択してください。');
        return;
      }

      if (state.isMail && state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id) && !x.email).length > 0) {
        alert('メールアドレスが設定されていない生徒が選択されています。\n生徒一覧から設定してください。');
        return;
      }

      if (!confirm('選択された生徒に答案を返却します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay", "答案返却中。画面を閉じずにそのままお待ちください。途中で画面を閉じると処理が中断されます。");

      state.isDispProgress = true;
      state.progress = "0.00";

      let completedCount = 0;

      // 生徒1名単位で返却APIを呼び出す
      for(let i = 0; i < state.examinees.length; i++){

        const examinee = state.examinees[i];
        
        // 未選択生徒はスキップ
        if(!state.selected_ids.includes(examinee.id)){
          continue;
        }

        const params = {sheet_id: state.sheet_id, examinee: examinee};

        await http.post(`/api/teacher/send_answer_image/create_mail`, params).then(response => {

          // 返却日時を更新
          examinee.last_sent_at = Common.formatDate(response.data.last_sent_at, 'yyyy年MM月DD日 HH:mm:ss');
          examinee.returnCompleted = true;
          context.root.$set(state.examinees, i, examinee);
          completedCount++;
          state.progress = Number.parseFloat(`${completedCount * 100 / state.selected_ids.length}`).toFixed(2);
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。返却に成功した生徒は返却日時が更新されています。失敗した生徒は再度返却を行ってください。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          state.isDispProgress = false;
          return;
        }
      }

      await resolveAfterMilliSeconds();

      alert("処理が完了しました。");
      context.root.$store.dispatch("hideOverlay");
      context.root.$store.dispatch('goSheetList');
    }

    /************************************************************
     * Classroom用 答案返却ボタン押下
     ************************************************************/

    const sendAnswerImageClassroom = async () => {

      state.errors = [];

      if (state.selected_ids.length == 0) {
        alert('答案返却対象の生徒を選択してください。');
        return;
      }

      if (!confirm('選択された生徒に答案を返却します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay", "答案返却中。画面を閉じずにそのままお待ちください。途中で画面を閉じると処理が中断されます。");

      state.isDispProgress = true;
      state.progress = "0.00";

      const examinees = state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id)).map((x: Examinee) => new Examinee(x));
      const params = {sheet_id: state.sheet_id, examinees: examinees, credentials: context.root.$store.state.gauthCredentials};

      // エラーチェック
      await http.post(`/api/teacher/send_answer_image/crass_room_error_check`, params).then(response => {
        if (response.data.error_type == "gapiAuthError") {
          alert("googleapiの認証に失敗しました。試験一覧に戻ります。");
          context.root.$store.dispatch('goSheetList');
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      // エラーありの場合は処理終了
      if(state.errors.length > 0){
        context.root.$store.dispatch("hideOverlay");
        state.isDispProgress = false;
        return;
      }

      let completedCount = 0;

      // 生徒1名単位で返却APIを呼び出す
      for(let i = 0; i < state.examinees.length; i++){

        const examinee = state.examinees[i];
        
        // 未選択生徒はスキップ
        if(!state.selected_ids.includes(examinee.id)){
          continue;
        }

        const params = {sheet_id: state.sheet_id, examinee: examinee, credentials: context.root.$store.state.gauthCredentials};

        await http.post(`/api/teacher/send_answer_image/crass_room_return_image`, params).then(response => {
          if (response.data.error_type == "gapiAuthError") {
            alert("googleapiの認証に失敗しました。試験一覧に戻ります。");
            context.root.$store.dispatch('goSheetList');
          }

          // 返却日時を更新
          examinee.last_sent_at = Common.formatDate(response.data.last_sent_at, 'yyyy年MM月DD日 HH:mm:ss');
          examinee.returnCompleted = true;
          context.root.$set(state.examinees, i, examinee);
          completedCount++;
          state.progress = Number.parseFloat(`${completedCount * 100 / state.selected_ids.length}`).toFixed(2);
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。返却に成功した生徒は返却日時が更新されています。失敗した生徒は再度返却を行ってください。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          state.isDispProgress = false;
          return;
        }
      }

      await resolveAfterMilliSeconds();

      alert("処理が完了しました。");
      context.root.$store.dispatch("hideOverlay");
      context.root.$store.dispatch('goSheetList');
      
    };

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 1);
      });
    }


    /************************************************************
     * 公開状態更新
     ************************************************************/

    const updatePublishing = async () => {

      if (!confirm('公開停止状態を更新します。よろしいですか？')) {
        return;
      }

      await http.post(`/api/teacher/send_answer_image/update_stop_publishing`, {sheet_id: state.sheet_id, examinees: state.examinees}).then(response => {
        alert("処理が完了しました。");
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");

    };

    /************************************************************
     * モーダルのtitleを返却
     ************************************************************/

    const modalTitle = computed((): string => {
      if(state.modalExaminee == null){
        return "";
      }

      if(state.isMail){
        return `採点結果　クラス名：${state.modalExaminee.room_name}　出席番号：${state.modalExaminee.student_no}番　氏名：${state.modalExaminee.student_name}`;
      }else if(state.isClassroom){
        return `採点結果　コース名：${state.modalExaminee.course_name}　クラス名：${state.modalExaminee.room_name}　出席番号：${state.modalExaminee.student_no}番　氏名：${state.modalExaminee.student_name}`;
      }
    });

    /************************************************************
     * 画像モーダル表示
     ************************************************************/

    const showPreviewImage = async (examinee: Examinee) => {

      if(examinee.base64Images.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage(examinee)
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }
      state.isShowCarousel = true;
      state.carouselPageIdx = 0;
      state.modalExaminee = examinee;
      modalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadImage = async (examinee: Examinee) => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const sheetActivityIds = examinee.sheetActivities.map(x => x.id);
      await http.get(`/api/teacher/send_answer_image/download_image/${examinee.sheet_id}/${sheetActivityIds}`).then(response => {
        response.data.base64_images.forEach((x: string) => {
          examinee.base64Images.push(x);
        });
      })
      .catch(error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/
    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.sheet.page_count - 1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/
    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.sheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };
    
    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx - 1; i >= 0; i--){
        const examinee = state.examinees[i];
        if(examinee.base64Images.length == 0){
          // 画像をダウンロード
          const isSuccess: boolean = await downloadImage(examinee)
          if(!isSuccess){
            // ダウンロード失敗は処理終了
            return;
          }
        }
        state.modalExaminee = examinee;
        carouselRef.value.setSlide(state.carouselPageIdx);
        break;
      }
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx + 1; state.examinees.length; i++){
        const examinee = state.examinees[i];
          if(examinee.base64Images.length == 0){
            // 画像をダウンロード
            const isSuccess: boolean = await downloadImage(examinee)
            if(!isSuccess){
              // ダウンロード失敗は処理終了
              return;
            }
          }
          state.modalExaminee = examinee;
          carouselRef.value.setSlide(state.carouselPageIdx);
          break;
      }
    };

    /************************************************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      state.windowHeight = windowHeight;
    };

    watch(() => state.isAllChecked, (newVal, oldVal) => {

      state.selected_ids = [];

      if (newVal) {

        state.selected_ids = state.examinees.map(x => x.id);
      }
    });

    watch(() => state.isAllCheckedStopPublishing, (newVal, oldVal) => {
      state.examinees.forEach(x => x.is_stop_publishing = newVal);
    });

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      
      let method = "";
      if(state.isClassroom){
        method = "index_classroom";
      }else if(context.root.$store.getters.isOptionStudentManageActive){
        method = "index_mail_student_manage";
      }else{
        method = "index_mail";
      }
      
      await http.get(`/api/teacher/send_answer_image/${method}?sheet_id=${state.sheet_id}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.examinees = response.data.examinees.map((x: any) => new Examinee(x));
        state.examinees.forEach((examinee: Examinee) => {
          state.selected_ids.push(examinee.id);
        });
        state.isAllChecked = true;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch('goSheetList');
      });
      context.root.$store.dispatch("hideOverlay");

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
    });

    return {
      ...toRefs(state),
      modalRef,
      carouselRef,
      convertExecDateText,
      tableFields,
      modalTitle,
      showPreviewImage,
      carouselPrev,
      carouselNext,
      changePrevModalExaminee,
      changeNextModalExaminee,
      adjustHeight,
      updatePublishing,
      sendAnswerImageClassroom,
      rowStyle,
      sendAnswerImageMail,
    }
  }
});

